import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { DialogTitle as HeadlessDialogTitle } from "@headlessui/vue";
import { useAttrs, computed } from "vue";

interface TitleProps extends ExtractProps<typeof HeadlessDialogTitle> {
  as?: string | object;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Title',
  props: {
    as: { default: "div" }
  },
  setup(__props: any) {

const { as } = __props as { as: string | object }



const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    "flex items-center px-5 py-3 border-b border-slate-200/60 dark:border-darkmode-400",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HeadlessDialogTitle), { as: "template" }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(as), _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"]))
    ]),
    _: 3
  }))
}
}

})